<div class="loading-overlay" *ngIf="is_loading">
        <div class="loading-container">
            <div class="loading"></div>
        </div>
    </div>